// extracted by mini-css-extract-plugin
module.exports = {"root":"view-header_root_1xotD","button":"view-header_button_1kC4b","active":"view-header_active_YHDcb","btnExport":"view-header_btnExport_2ExLl","mr":"view-header_mr_2TUB3"};